import React, { ForwardedRef } from 'react';

const TitleSubtitle = React.forwardRef(
  ({ title = '', subtitle = '', type = '' }: any, ref: ForwardedRef<HTMLSpanElement>) => {
    return (
      <>
        <span className="d-flex flex-column mb-7" ref={ref}>
          <span className="fw-bold fs-3">{title}</span>
          <span className={`fs-6 text-${type}`}>{subtitle}</span>
        </span>
      </>
    );
  }
);

export default TitleSubtitle;
